webpackJsonp([1],{

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Activities__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Activities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Activities__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/:login/:key',
    name: 'Activities',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Activities___default.a
  }]
}));

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(32);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_flatpickr_da__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_flatpickr_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_flatpickr_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);











__WEBPACK_IMPORTED_MODULE_8_moment__["locale"]('da');

var config = {
  apiKey: 'AIzaSyAynycu2fcbWAusFICFIN026B-sw32js8o',
  authDomain: 'hscamping-9c323.firebaseapp.com',
  databaseURL: 'https://hscamping-9c323.firebaseio.com',
  storageBucket: 'hscamping-9c323.appspot.com',
  messagingSenderId: '761576838574'
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(config);
var db = firebaseApp.database();

var usersRef = db.ref('users');
var activitiesRef = db.ref('activities');
var seriesRef = db.ref('series');
var contactRef = db.ref('contact');
var signupNotesRef = db.ref('settings/signupNotes');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Modal: __WEBPACK_IMPORTED_MODULE_5__Modal___default.a, VueTimepicker: __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default.a },
  data: function data() {
    return {
      activeTab: 'activities',
      currentLang: 'da',
      currentSearch: '',
      currentDate: '',
      previewImage: null,
      activeActivity: null,
      activeSeries: null,
      inputLanguage: null,
      signupNotesInputLanguage: null,

      showTooManyParticipants: false,
      newActivity: null,
      submittable: false,
      submitAttempt: false,
      activityCreated: false,
      seriesCreated: false,
      creatingActivity: false,
      updatingActiveActivity: false,
      deletingOldActivities: false,
      oldActivitiesDeleted: false,
      contactUpdated: false,
      signupNotesUpdated: false,
      activeActivityUpdated: false,
      activeActivityFile: null,
      activeActivityPreviewImage: null,
      noActivitiesInSeries: false,
      today: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD'),
      aMonthFromNow: __WEBPACK_IMPORTED_MODULE_8_moment__().add(1, 'months').format('YYYY-MM-DD'),
      yesterday: __WEBPACK_IMPORTED_MODULE_8_moment__().add(-1, 'days').toDate(),
      aMonthAgo: __WEBPACK_IMPORTED_MODULE_8_moment__().add(-1, 'months').toDate(),
      participantToAdd: '',
      participantToRemove: {
        key: null,
        activity: null
      },
      participantToConfirm: {
        key: null,
        activity: null,
        confirm: null
      },
      activityToDelete: null,
      seriesToDelete: null,
      modal: {
        show: false,
        header: 'Bekræft handling',
        body: 'Er du sikker?',
        action: null,
        ok: 'OK',
        close: 'FORTRYD'
      },
      fpOptions: {
        locale: __WEBPACK_IMPORTED_MODULE_7__assets_flatpickr_da__["da"],
        altInput: true,
        altFormat: 'j. F Y'
      },
      fpOptionsRange: {
        locale: __WEBPACK_IMPORTED_MODULE_7__assets_flatpickr_da__["da"],
        altInput: true,
        altFormat: 'j. F Y',
        mode: 'range'
      },
      dataLoaded: false,
      authorized: true
    };
  },

  firebase: {
    users: usersRef,
    activities: activitiesRef,
    series: seriesRef,
    contact: {
      source: contactRef,
      asObject: true
    },
    signupNotes: {
      source: signupNotesRef,
      asObject: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    activitiesRef.once('value', function (snapshot) {
      _this.dataLoaded = true;
    });
  },
  created: function created() {
    var _this2 = this;

    this.currentUser = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signInWithEmailAndPassword(this.$route.params.login, this.$route.params.key).then(function () {
      _this2.authorized = true;
    }).catch(function (error) {
      _this2.authorized = false;
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode + ' ' + errorMessage);
    });
    this.resetInputLang();
    this.resetNewActivity();
  },

  methods: {
    filter: function filter(activities) {
      var _this3 = this;

      if (this.currentDate !== '') {
        activities = activities.filter(function (activity) {
          return __WEBPACK_IMPORTED_MODULE_8_moment__(activity.date).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_8_moment__(_this3.currentDateRange.from)) && __WEBPACK_IMPORTED_MODULE_8_moment__(activity.date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_8_moment__(_this3.currentDateRange.to));
        });
      } else {
        activities = activities.filter(function (activity) {
          return __WEBPACK_IMPORTED_MODULE_8_moment__(activity.date).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_8_moment__(_this3.today)) && __WEBPACK_IMPORTED_MODULE_8_moment__(activity.date).isSameOrBefore(__WEBPACK_IMPORTED_MODULE_8_moment__(_this3.today).add(1, 'months'));
        });
      }
      if (this.currentSearch !== '') {
        activities = activities.filter(function (activity) {
          return activity.title[_this3.currentLang].toLowerCase().includes(_this3.currentSearch.toLowerCase());
        });
      }
      return activities;
    },
    isPastActivity: function isPastActivity(activity) {
      return __WEBPACK_IMPORTED_MODULE_8_moment__(activity.date).add(activity.endTimeInMinutes, 'minutes').isBefore(__WEBPACK_IMPORTED_MODULE_8_moment__());
    },
    getActivity: function getActivity(id) {
      return this.activities.find(function (activity) {
        return activity['.key'] === id;
      });
    },
    getSeries: function getSeries(id) {
      return this.series.find(function (series) {
        return series['.key'] === id;
      });
    },
    getFirstActivityKey: function getFirstActivityKey(series) {
      if (!series.activities) return;
      var activitiesList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(series.activities).map(function (key) {
        return { key: key, value: series.activities[key] };
      });
      return activitiesList[0] ? activitiesList[0].value : null;
    },
    getActivities: function getActivities(date) {
      return this.activities.filter(function (activity) {
        return activity.date === date;
      }).sort(function (a, b) {
        if (a.startTimeInMinutes > b.startTimeInMinutes) {
          return 1;
        }
        if (a.startTimeInMinutes < b.startTimeInMinutes) {
          return -1;
        }
        return 0;
      });
    },
    confirmParticipantModal: function confirmParticipantModal(participant, activity, confirm) {
      this.modal.action = this.confirmParticipant;
      this.participantToConfirm.key = participant.key;
      this.participantToConfirm.activity = activity;
      this.participantToConfirm.confirm = confirm;
      this.modal.header = 'Bekræft tilmelding';
      this.modal.body = 'Afkræft tilmelding (og betaling) for ' + participant.name + '?';
      if (confirm) {
        this.modal.body = 'Bekræft tilmelding (og betaling) for ' + participant.name + '?';
      }
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    confirmParticipant: function confirmParticipant() {
      activitiesRef.child(this.participantToConfirm.activity['.key'] + '/participants/' + this.participantToConfirm.key).update({ 'confirmed': this.participantToConfirm.confirm });
    },
    getParticipants: function getParticipants(activity) {
      var _this4 = this;

      var participants = this.activities.find(function (act) {
        return act['.key'] === activity['.key'];
      }).participants;

      if (!participants) {
        return;
      }

      var participantsList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(participants).map(function (key) {
        return { key: key, value: participants[key] };
      });

      return participantsList.map(function (participant) {
        return _this4.findUser(participant.value, participant.key);
      }).sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    },
    findUser: function findUser(participant, key) {
      var user = this.users.find(function (user) {
        return user['.key'] === participant.uid;
      });
      if (user === undefined) return { name: participant.uid, confirmed: participant.confirmed, key: key };
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, user, { confirmed: participant.confirmed, key: key });
    },
    getParticipantsAmount: function getParticipantsAmount(activity) {
      var participants = this.activities.find(function (act) {
        return act['.key'] === activity['.key'];
      }).participants;
      if (!participants) return 0;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(participants).length;
    },
    getMaxAmountOfParticipants: function getMaxAmountOfParticipants(activity) {
      return this.activities.find(function (act) {
        return act['.key'] === activity['.key'];
      }).maxAmountOfParticipants;
    },
    removeParticipantModal: function removeParticipantModal(participant, activity) {
      this.modal.action = this.removeParticipant;
      this.participantToRemove.key = participant.key;
      this.participantToRemove.activity = activity;
      this.modal.header = 'Fjern deltager';
      this.modal.body = 'Fjern ' + participant.name + ' fra deltagerlisten?';
      if (participant.confirmed) {
        this.modal.body += '<br/><span style="color:red">Deltager står som bekræftet til aktiviteten</span>';
      }
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    removeParticipant: function removeParticipant() {
      activitiesRef.child(this.participantToRemove.activity['.key'] + '/participants/' + this.participantToRemove.key).remove();
    },
    addParticipantModal: function addParticipantModal() {
      var _this5 = this;

      if (!this.participantToAdd) return;

      var participants = this.activities.find(function (act) {
        return act['.key'] === _this5.activeActivity['.key'];
      }).participants;

      if (participants && this.activeActivity.maxAmountOfParticipants != null && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(participants).length >= this.activeActivity.maxAmountOfParticipants || !participants && this.activeActivity.maxAmountOfParticipants != null && this.activeActivity.maxAmountOfParticipants === 0) {
        this.showTooManyParticipants = true;
        setTimeout(function () {
          _this5.showTooManyParticipants = false;
        }, 5000);
        return;
      }

      this.modal.action = this.addParticipant;
      this.modal.header = 'Tilmeld ' + this.participantToAdd + '?';
      this.modal.body = '<span style="display:flex;"><label><input type="checkbox" id="confirmParticipant"> Bekræft tilmelding (og betaling)</label></span>';
      this.modal.ok = 'TILMELD';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    addParticipant: function addParticipant() {
      var _this6 = this;

      activitiesRef.child(this.activeActivity['.key']).once('value', function (snapshot) {
        if (snapshot.exists()) {
          activitiesRef.child(_this6.activeActivity['.key'] + '/participants/').push({ uid: _this6.participantToAdd, confirmed: document.getElementById('confirmParticipant').checked });
          _this6.participantToAdd = '';
        }
      });
    },
    deleteOldActivities: function deleteOldActivities() {
      var _this7 = this;

      var snapshot = this.activities.map(function (activity) {
        return activity;
      });

      this.deletingOldActivities = true;

      snapshot.forEach(function (activity) {
        if (new Date(activity.date).getTime() < _this7.aMonthAgo.getTime()) {
          _this7.deleteActivity(activity);
        }
      });

      this.deletingOldActivities = false;
      this.oldActivitiesDeleted = true;
      setTimeout(function () {
        _this7.oldActivitiesDeleted = false;
      }, 5000);
    },
    setActiveTab: function setActiveTab(tab) {
      this.activeTab = tab;
    },
    edit: function edit(activity) {
      this.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(activity));
      this.activeTab = 'edit-activity';
    },
    editSeries: function editSeries(series) {
      var activity = this.getActivity(this.getFirstActivityKey(series));

      this.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(activity));
      this.activeSeries = series;
      this.activeTab = 'edit-series';
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      this.newActivity.file = files[0];
      this.submittable = true;

      this.createPreviewImage(this.newActivity.file, 'new');
    },
    onActiveActivityFileChange: function onActiveActivityFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      this.activeActivityFile = files[0];

      this.createPreviewImage(this.activeActivityFile, 'active');
    },
    createPreviewImage: function createPreviewImage(file, target) {
      var reader = new FileReader();

      var vm = this;

      if (target === 'active') {
        reader.onload = function (e) {
          vm.activeActivityPreviewImage = e.target.result;
        };
      } else if (target === 'new') {
        reader.onload = function (e) {
          vm.previewImage = e.target.result;
        };
      }
      reader.readAsDataURL(file);
    },
    deleteSeriesModal: function deleteSeriesModal(series) {
      this.modal.action = this.deleteSeries;
      this.seriesToDelete = series;
      this.modal.header = 'Slet serie';
      this.modal.body = 'Fjern serie "' + this.getActivity(this.getFirstActivityKey(series)).title[this.currentLang] + '" fra kalenderen?';
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    deleteSeries: function deleteSeries(series) {
      var _this8 = this;

      if (!series) {
        series = this.seriesToDelete;
      }

      var ids = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(series.activities).map(function (key) {
        return { key: key, value: series.activities[key] };
      });

      var activitiesList = [];

      ids.forEach(function (id) {
        var activity = _this8.activities.find(function (activity) {
          return activity['.key'] === id.value;
        });
        if (activity) activitiesList.push(activity);
      });

      activitiesList.forEach(function (activity) {
        _this8.deleteActivity(activity);
      });
    },
    deleteActivityModal: function deleteActivityModal(activity) {
      this.modal.action = this.deleteActivity;
      this.activityToDelete = activity;
      this.modal.header = 'Slet aktivitet';
      this.modal.body = 'Fjern aktivitet "' + activity.title[this.currentLang] + '" fra kalenderen?';
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    removeActivityFromSeries: function removeActivityFromSeries(activityId, seriesId) {
      var activities = this.series.find(function (series) {
        return series['.key'] === seriesId;
      }).activities;

      if (!activities) {
        return;
      }

      var activitiesList = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(activities).map(function (key) {
        return { key: key, value: activities[key] };
      });

      activitiesList.forEach(function (activity) {
        if (activity.value === activityId) {
          seriesRef.child(seriesId + '/activities/' + activity.key).remove();
        }
      });

      this.checkDeleteEmptySeries(seriesId);
    },
    checkDeleteEmptySeries: function checkDeleteEmptySeries(seriesId) {
      var _this9 = this;

      seriesRef.child(seriesId + '/activities').once('value', function (snapshot) {
        if (!snapshot.exists()) {
          var imageRef = _this9.series.find(function (series) {
            return series['.key'] === seriesId;
          })['.key'];

          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('series/' + imageRef).delete().then(function () {
            seriesRef.child(seriesId).remove();
          });
        }
      });
    },
    deleteActivity: function deleteActivity(activity) {
      if (!activity) {
        activity = this.activityToDelete;
      }

      activitiesRef.child(activity['.key']).remove();

      if (activity.series) {
        this.removeActivityFromSeries(activity['.key'], activity.series);
        return;
      }

      var imageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('activities/' + activity['.key']);

      imageRef.delete();
    },
    createSeriesModal: function createSeriesModal() {
      var _this10 = this;

      this.submitAttempt = true;
      setTimeout(function () {
        _this10.submitAttempt = false;
      }, 5000);

      if (!this.submittable) {
        return;
      }
      var dates = this.getSelectedDates(this.getDates(this.newActivity.startDate, this.newActivity.endDate), this.newActivity.repeat, this.newActivity.repeatDays);

      if (!dates) return;

      if (dates.length === 0) {
        this.noActivitiesInSeries = true;
        setTimeout(function () {
          _this10.noActivitiesInSeries = false;
        }, 5000);
        return;
      }

      this.modal.action = this.createSeries;
      this.modal.header = 'Opret serie';
      this.modal.body = 'Dette vil oprette ' + dates.length + ' aktiviteter. Er du sikker?';
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    createActivityModal: function createActivityModal() {
      var _this11 = this;

      this.submitAttempt = true;
      setTimeout(function () {
        _this11.submitAttempt = false;
      }, 5000);

      if (!this.submittable) {
        return;
      }
      this.modal.action = this.createNewActivity;
      this.modal.header = 'Opret aktivitet';
      this.modal.body = 'Er du sikker?';
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    createNewActivity: function createNewActivity() {
      this.creatingActivity = true;

      var postKey = activitiesRef.push().key;
      var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('activities/' + postKey);

      var task = storageRef.put(this.newActivity.file);

      var vm = this;

      task.then(function () {
        var downloadURL = task.snapshot.downloadURL;

        var activity = vm.newActivity;

        var updates = {};
        var postData = {
          title: activity.title,
          about: activity.about,
          date: activity.date,
          startTimeInMinutes: vm.timeToTimeInMinutes(activity.startTime),
          endTimeInMinutes: vm.timeToTimeInMinutes(activity.endTime),
          location: activity.location,
          organiser: activity.organiser,
          info: activity.info,
          pic: downloadURL,
          visibleTo: activity.visibleTo,
          participants: null,
          interestedIn: null,
          who: activity.who,
          where: activity.where,
          what: activity.what,
          priceCategory: activity.priceCategory,
          price: activity.price ? Math.max(parseInt(activity.price, 10), 0) : 0,
          category: activity.category,
          maxAmountOfParticipants: activity.maxAmountOfParticipants ? Math.max(parseInt(activity.maxAmountOfParticipants, 10), 0) : null,
          pushNotificationMinInAdvance: parseInt(activity.pushNotificationMinInAdvance)
        };
        updates['activities/' + postKey] = postData;
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().update(updates).then(function () {
          vm.resetInputLang();
          vm.resetNewActivity();
          vm.activityCreated = true;
          vm.creatingActivity = false;
          setTimeout(function () {
            vm.activityCreated = false;
          }, 5000);
        });
      });
    },
    createSeries: function createSeries() {
      this.creatingActivity = true;

      var seriesKey = seriesRef.push().key;
      seriesRef.child(seriesKey).set({
        startDate: this.newActivity.startDate,
        endDate: this.newActivity.endDate,
        repeat: this.newActivity.repeat,
        repeatDays: this.newActivity.repeatDays
      });

      var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('series/' + seriesKey);

      var task = storageRef.put(this.newActivity.file);

      var vm = this;

      task.then(function () {
        var downloadURL = task.snapshot.downloadURL;
        var activity = vm.newActivity;

        var promises = [];

        var dates = vm.getSelectedDates(vm.getDates(activity.startDate, activity.endDate), activity.repeat, activity.repeatDays);

        dates.forEach(function (date) {
          var postData = {
            title: activity.title,
            about: activity.about,
            date: date,
            series: seriesKey,
            startTimeInMinutes: vm.timeToTimeInMinutes(activity.startTime),
            endTimeInMinutes: vm.timeToTimeInMinutes(activity.endTime),
            location: activity.location,
            organiser: activity.organiser,
            info: activity.info,
            pic: downloadURL,
            visibleTo: activity.visibleTo,
            participants: null,
            interestedIn: null,
            who: activity.who,
            where: activity.where,
            what: activity.what,
            priceCategory: activity.priceCategory,
            price: activity.price ? Math.max(parseInt(activity.price, 10), 0) : 0,
            category: activity.category,
            maxAmountOfParticipants: activity.maxAmountOfParticipants ? Math.max(parseInt(activity.maxAmountOfParticipants, 10), 0) : null,
            pushNotificationMinInAdvance: parseInt(activity.pushNotificationMinInAdvance)
          };
          promises.concat(vm.createActivity(postData, seriesKey));
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (values) {
          vm.resetInputLang();
          vm.resetNewActivity();
          vm.seriesCreated = true;
          vm.creatingActivity = false;
          setTimeout(function () {
            vm.seriesCreated = false;
          }, 5000);
        });
      });
    },
    createActivity: function createActivity(postData, seriesKey) {
      var promises = [];

      var postKey = activitiesRef.push().key;
      var updates = {};
      updates['activities/' + postKey] = postData;
      promises.push(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().update(updates));
      promises.push(seriesRef.child(seriesKey + '/activities/').push(postKey));
      return promises;
    },
    updateContact: function updateContact() {
      var _this12 = this;

      var updates = {
        info: this.contact.info
      };

      contactRef.update(updates).then(function () {
        _this12.contactUpdated = true;
        var vm = _this12;
        setTimeout(function () {
          vm.contactUpdated = false;
        }, 5000);
      });
    },
    updateSignupNotes: function updateSignupNotes() {
      var _this13 = this;

      var updates = {
        hereAndNow: this.signupNotes.hereAndNow,
        binding: this.signupNotes.binding,
        free: this.signupNotes.free,
        offSite: this.signupNotes.offSite
      };

      signupNotesRef.update(updates).then(function () {
        _this13.signupNotesUpdated = true;
        var vm = _this13;
        setTimeout(function () {
          vm.signupNotesUpdated = false;
        }, 5000);
      });
    },
    updateActiveSeriesModal: function updateActiveSeriesModal() {
      this.modal.action = this.updateActiveSeries;
      this.modal.header = 'Opdater serie';
      this.modal.body = 'Opdater serien og alle tilknyttede aktiviteter?';
      this.modal.ok = 'OK';
      this.modal.close = 'FORTRYD';
      this.modal.show = true;
    },
    updateActiveSeries: function updateActiveSeries() {
      var _this14 = this;

      this.updatingActiveActivity = true;

      var ids = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.activeSeries.activities).map(function (key) {
        return { key: key, value: _this14.activeSeries.activities[key] };
      });

      var activitiesList = [];

      ids.forEach(function (id) {
        var activity = _this14.activities.find(function (activity) {
          return activity['.key'] === id.value;
        });
        if (activity) activitiesList.push(activity);
      });

      activitiesList.forEach(function (activity) {
        var key = activity['.key'];

        var imageKey = _this14.activeSeries['.key'];

        var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('series/' + imageKey);
        var currentActivityRef = activitiesRef.child(key);

        var vm = _this14;

        var act = _this14.activeActivity;

        if (_this14.activeActivityFile) {
          var task = storageRef.put(_this14.activeActivityFile);

          task.then(function () {
            var downloadURL = task.snapshot.downloadURL;

            currentActivityRef.update({ pic: downloadURL }).then(function () {
              vm.activeActivityUpdated = true;
              vm.updatingActiveActivity = false;
              vm.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.activities.find(function (a) {
                return a['.key'] === act['.key'];
              })));
              setTimeout(function () {
                vm.activeActivityUpdated = false;
              }, 5000);
            });
          });
        }

        currentActivityRef.update({
          title: act.title,
          about: act.about,
          startTimeInMinutes: _this14.timeToTimeInMinutes(_this14.activeActivityStartTime),
          endTimeInMinutes: _this14.timeToTimeInMinutes(_this14.activeActivityEndTime),
          location: act.location,
          organiser: act.organiser,
          info: act.info,
          visibleTo: act.visibleTo,
          who: act.who,
          where: act.where,
          what: act.what,
          priceCategory: act.priceCategory,
          price: act.price ? Math.max(parseInt(act.price, 10), 0) : 0,
          category: act.category,
          maxAmountOfParticipants: act.maxAmountOfParticipants ? Math.max(parseInt(act.maxAmountOfParticipants, 10), 0) : null,
          pushNotificationMinInAdvance: parseInt(act.pushNotificationMinInAdvance)
        }).then(function () {
          if (!_this14.activeActivityFile) {
            _this14.activeActivityUpdated = true;
            _this14.updatingActiveActivity = false;
            _this14.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.activities.find(function (a) {
              return a['.key'] === act['.key'];
            })));
            setTimeout(function () {
              _this14.activeActivityUpdated = false;
            }, 5000);
          }
        });
      });
    },
    updateActiveActivityModal: function updateActiveActivityModal() {
      if (this.activeActivity.series) {
        this.modal.action = this.updateActiveActivity;
        this.modal.header = 'Opdater aktivitet';
        this.modal.body = 'Aktiviteten vil ikke længere være en del af sin serie. Er du sikker?';
        this.modal.ok = 'OK';
        this.modal.close = 'FORTRYD';
        this.modal.show = true;
      } else {
        this.modal.action = this.updateActiveActivity;
        this.modal.header = 'Opdater aktivitet';
        this.modal.body = 'Er du sikker?';
        this.modal.ok = 'OK';
        this.modal.close = 'FORTRYD';
        this.modal.show = true;
      }
    },
    updateActiveActivity: function updateActiveActivity() {
      var _this15 = this;

      this.updatingActiveActivity = true;
      var key = this.activeActivity['.key'];

      var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('activities/' + key);
      var activeActivityRef = activitiesRef.child(key);

      if (this.activeActivity.series && !this.activeActivityFile) {
        var seriesImageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref('series/' + this.activeActivity.series);
        seriesImageRef.getDownloadURL().then(function (url) {
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          xhr.onload = function (event) {
            var blob = xhr.response;

            storageRef.put(blob).then(function (snapshot) {
              activeActivityRef.update({
                pic: snapshot.downloadURL
              });
              _this15.removeActivityFromSeries(key, _this15.activeActivity.series);
              activeActivityRef.child('series').remove();
            });
          };
          xhr.open('GET', url);
          xhr.send();
        });
      }

      if (this.activeActivity.series && this.activeActivityFile) {
        this.removeActivityFromSeries(key, this.activeActivity.series);
        activeActivityRef.child('series').remove();
      }

      var vm = this;

      var activity = this.activeActivity;

      if (this.activeActivityFile) {
        var task = storageRef.put(this.activeActivityFile);

        task.then(function () {
          var downloadURL = task.snapshot.downloadURL;

          activeActivityRef.update({
            pic: downloadURL
          }).then(function () {
            vm.activeActivityUpdated = true;
            vm.updatingActiveActivity = false;
            vm.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(vm.activities.find(function (act) {
              return act['.key'] === activity['.key'];
            })));
            setTimeout(function () {
              vm.activeActivityUpdated = false;
            }, 5000);
          });
        });
      }

      activeActivityRef.update({
        title: activity.title,
        about: activity.about,
        date: activity.date,
        startTimeInMinutes: this.timeToTimeInMinutes(this.activeActivityStartTime),
        endTimeInMinutes: this.timeToTimeInMinutes(this.activeActivityEndTime),
        location: activity.location,
        organiser: activity.organiser,
        info: activity.info,
        visibleTo: activity.visibleTo,
        who: activity.who,
        where: activity.where,
        what: activity.what,
        priceCategory: activity.priceCategory,
        price: activity.price ? Math.max(parseInt(activity.price, 10), 0) : 0,
        category: activity.category,
        maxAmountOfParticipants: activity.maxAmountOfParticipants ? Math.max(parseInt(activity.maxAmountOfParticipants, 10), 0) : null,
        pushNotificationMinInAdvance: parseInt(activity.pushNotificationMinInAdvance)
      }).then(function () {
        if (!_this15.activeActivityFile) {
          _this15.activeActivityUpdated = true;
          _this15.updatingActiveActivity = false;
          _this15.activeActivity = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this15.activities.find(function (act) {
            return act['.key'] === activity['.key'];
          })));
          setTimeout(function () {
            _this15.activeActivityUpdated = false;
          }, 5000);
        }
      });
    },
    displayGuestOn: function displayGuestOn(guestOn) {
      if (guestOn === 'camping') {
        return 'HSC';
      } else if (guestOn === 'partner') {
        return 'FP';
      }
      return '';
    },
    timeToTimeInMinutes: function timeToTimeInMinutes(time) {
      var hours = parseInt(time.HH, 10);
      var minutes = parseInt(time.mm, 10);

      return hours * 60 + minutes;
    },
    timeInMinutesToTime: function timeInMinutesToTime(timeInMinutes) {
      var hours = Math.floor(timeInMinutes / 60).toString();
      var minutes = (timeInMinutes % 60).toString();

      hours = hours.length === 1 ? '0' + hours : hours;
      minutes = minutes.length === 1 ? '0' + minutes : minutes;

      return {
        HH: hours,
        mm: minutes
      };
    },
    onActiveActivityStartTimeChanged: function onActiveActivityStartTimeChanged(eventData) {
      this.activeActivity.startTimeInMinutes = this.timeToTimeInMinutes(eventData.data);
    },
    onActiveActivityEndTimeChanged: function onActiveActivityEndTimeChanged(eventData) {
      this.activeActivity.endTimeInMinutes = this.timeToTimeInMinutes(eventData.data);
    },
    getDates: function getDates(startDate, endDate) {
      var dates = [];
      var now = __WEBPACK_IMPORTED_MODULE_8_moment__(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_8_moment__(endDate);

      while (now.isBefore(endDate) || now.isSame(endDate)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
      }

      return dates;
    },
    mapRepeatToReadableRepeat: function mapRepeatToReadableRepeat(repeat) {
      switch (repeat) {
        case 'daily':
          return 'daglig';
        case 'weekly':
          return 'ugentlig';
        case 'monthly':
          return 'månedlig';
      }
    },
    mapRepeatDaysToReadableDays: function mapRepeatDaysToReadableDays(repeatDays) {
      return repeatDays.map(function (day) {
        switch (parseInt(day, 10)) {
          case 0:
            return 'mandag';
          case 1:
            return 'tirsdag';
          case 2:
            return 'onsdag';
          case 3:
            return 'torsdag';
          case 4:
            return 'fredag';
          case 5:
            return 'lørdag';
          case 6:
            return 'søndag';
        }
      });
    },
    getSelectedDates: function getSelectedDates(dates, repeat, repeatDays) {
      if (repeat === 'daily') {
        return dates;
      }

      var selectedDays = [];
      repeatDays = repeatDays.map(function (day) {
        return parseInt(day, 10);
      });

      if (repeat === 'weekly') {
        dates.forEach(function (date) {
          if (repeatDays.indexOf(__WEBPACK_IMPORTED_MODULE_8_moment__(date).weekday()) >= 0) {
            selectedDays.push(date);
          }
        });
      } else if (repeat === 'monthly') {
        dates.forEach(function (date) {
          if (repeatDays.indexOf(__WEBPACK_IMPORTED_MODULE_8_moment__(date).weekday()) >= 0 && __WEBPACK_IMPORTED_MODULE_8_moment__(date).date() <= 7) {
            selectedDays.push(date);
          }
        });
      }
      return selectedDays;
    },
    resetInputLang: function resetInputLang() {
      this.inputLanguage = { title: 'da', about: 'da', location: 'da', info: 'da' };
      this.signupNotesInputLanguage = { hereAndNow: 'da', binding: 'da', free: 'da', offSite: 'da' };
      this.contactInputLanguage = { about: 'da' };
    },
    resetCurrentDate: function resetCurrentDate() {
      this.$refs.flatpickr.$el._flatpickr.setDate('');
    },
    resetNewActivity: function resetNewActivity() {
      this.submittable = false;
      this.submitAttempt = false;
      this.previewImage = null;

      var newFile = this.$refs.newActivityFile;
      if (newFile) {
        newFile.value = '';
        newFile.type = '';
        newFile.type = 'file';
      }

      this.newActivity = {
        title: {
          da: '',
          de: ''
        },
        about: {
          da: '',
          de: ''
        },
        date: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD'),
        startDate: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD'),
        endDate: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD'),
        repeat: 'daily',
        repeatDays: [],
        startTime: {
          HH: '12',
          mm: '00'
        },
        endTime: {
          HH: '12',
          mm: '00'
        },
        location: {
          da: '',
          de: ''
        },
        organiser: '',
        info: {
          da: '',
          de: ''
        },
        file: null,
        visibleTo: 'everyone',
        who: '',
        where: '',
        what: '',
        priceCategory: 'freeForAll',
        price: 0,
        category: 'free',
        maxAmountOfParticipants: null,
        pushNotificationMinInAdvance: 0
      };
    }
  },
  computed: {
    activeActivityStartTime: function activeActivityStartTime() {
      return this.timeInMinutesToTime(this.activeActivity.startTimeInMinutes);
    },
    activeActivityEndTime: function activeActivityEndTime() {
      return this.timeInMinutesToTime(this.activeActivity.endTimeInMinutes);
    },
    dates: function dates() {
      var res = [];

      this.filter(this.activities).forEach(function (activity) {
        if (res.indexOf(activity.date) < 0) {
          res.push(activity.date);
        }
      });

      res.sort(function (a, b) {
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      });

      return res;
    },
    currentDateRange: function currentDateRange() {
      var dates = this.currentDate.split(' ');

      if (dates.length === 1) {
        return { from: this.currentDate, to: this.currentDate };
      } else if (dates.length === 3) {
        return { from: dates[0], to: dates[2] };
      } else {
        return { from: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD'), to: __WEBPACK_IMPORTED_MODULE_8_moment__().format('YYYY-MM-DD') };
      }
    }
  },
  watch: {
    activeTab: function activeTab(newVal) {
      if (newVal !== 'edit-activity') {
        this.activeActivityUpdated = false;
        this.activeActivityFile = null;
        this.activeActivityPreviewImage = null;
        this.participantToAdd = '';
      }
      this.resetInputLang();
      this.resetNewActivity();
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    ok: { default: 'OK' },
    close: { default: 'FORTRYD' }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {


var Flatpickr = Flatpickr || { l10ns: {} };
Flatpickr.l10ns.da = {};

Flatpickr.l10ns.da.weekdays = {
	shorthand: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
	longhand: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};

Flatpickr.l10ns.da.months = {
	shorthand: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
	longhand: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
};

Flatpickr.l10ns.da.ordinal = function () {
	return ".";
};

Flatpickr.l10ns.da.firstDayOfWeek = 1;

if (true) {
	module.exports = Flatpickr.l10ns;
}

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_flatpickr___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('localizeDate', function (date) {
    var d = __WEBPACK_IMPORTED_MODULE_7_moment__(date);
    d.locale('da');

    var dayOfWeek = d.format('dddd');
    var stringDate = d.format('LL');

    return dayOfWeek + ", " + stringDate;
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('localizeDateSimple', function (date) {
    var d = __WEBPACK_IMPORTED_MODULE_7_moment__(date);
    d.locale('da');

    var stringDate = d.format('LL');

    return stringDate;
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('minutesToTimeOfDay', function (minutes) {
    return __WEBPACK_IMPORTED_MODULE_7_moment__["utc"]().startOf('day').add(minutes, 'minutes').format("HH:mm");
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 47,
	"./af.js": 47,
	"./ar": 54,
	"./ar-dz": 48,
	"./ar-dz.js": 48,
	"./ar-kw": 49,
	"./ar-kw.js": 49,
	"./ar-ly": 50,
	"./ar-ly.js": 50,
	"./ar-ma": 51,
	"./ar-ma.js": 51,
	"./ar-sa": 52,
	"./ar-sa.js": 52,
	"./ar-tn": 53,
	"./ar-tn.js": 53,
	"./ar.js": 54,
	"./az": 55,
	"./az.js": 55,
	"./be": 56,
	"./be.js": 56,
	"./bg": 57,
	"./bg.js": 57,
	"./bm": 58,
	"./bm.js": 58,
	"./bn": 59,
	"./bn.js": 59,
	"./bo": 60,
	"./bo.js": 60,
	"./br": 61,
	"./br.js": 61,
	"./bs": 62,
	"./bs.js": 62,
	"./ca": 63,
	"./ca.js": 63,
	"./cs": 64,
	"./cs.js": 64,
	"./cv": 65,
	"./cv.js": 65,
	"./cy": 66,
	"./cy.js": 66,
	"./da": 67,
	"./da.js": 67,
	"./de": 70,
	"./de-at": 68,
	"./de-at.js": 68,
	"./de-ch": 69,
	"./de-ch.js": 69,
	"./de.js": 70,
	"./dv": 71,
	"./dv.js": 71,
	"./el": 72,
	"./el.js": 72,
	"./en-SG": 73,
	"./en-SG.js": 73,
	"./en-au": 74,
	"./en-au.js": 74,
	"./en-ca": 75,
	"./en-ca.js": 75,
	"./en-gb": 76,
	"./en-gb.js": 76,
	"./en-ie": 77,
	"./en-ie.js": 77,
	"./en-il": 78,
	"./en-il.js": 78,
	"./en-nz": 79,
	"./en-nz.js": 79,
	"./eo": 80,
	"./eo.js": 80,
	"./es": 83,
	"./es-do": 81,
	"./es-do.js": 81,
	"./es-us": 82,
	"./es-us.js": 82,
	"./es.js": 83,
	"./et": 84,
	"./et.js": 84,
	"./eu": 85,
	"./eu.js": 85,
	"./fa": 86,
	"./fa.js": 86,
	"./fi": 87,
	"./fi.js": 87,
	"./fo": 88,
	"./fo.js": 88,
	"./fr": 91,
	"./fr-ca": 89,
	"./fr-ca.js": 89,
	"./fr-ch": 90,
	"./fr-ch.js": 90,
	"./fr.js": 91,
	"./fy": 92,
	"./fy.js": 92,
	"./ga": 93,
	"./ga.js": 93,
	"./gd": 94,
	"./gd.js": 94,
	"./gl": 95,
	"./gl.js": 95,
	"./gom-latn": 96,
	"./gom-latn.js": 96,
	"./gu": 97,
	"./gu.js": 97,
	"./he": 98,
	"./he.js": 98,
	"./hi": 99,
	"./hi.js": 99,
	"./hr": 100,
	"./hr.js": 100,
	"./hu": 101,
	"./hu.js": 101,
	"./hy-am": 102,
	"./hy-am.js": 102,
	"./id": 103,
	"./id.js": 103,
	"./is": 104,
	"./is.js": 104,
	"./it": 106,
	"./it-ch": 105,
	"./it-ch.js": 105,
	"./it.js": 106,
	"./ja": 107,
	"./ja.js": 107,
	"./jv": 108,
	"./jv.js": 108,
	"./ka": 109,
	"./ka.js": 109,
	"./kk": 110,
	"./kk.js": 110,
	"./km": 111,
	"./km.js": 111,
	"./kn": 112,
	"./kn.js": 112,
	"./ko": 113,
	"./ko.js": 113,
	"./ku": 114,
	"./ku.js": 114,
	"./ky": 115,
	"./ky.js": 115,
	"./lb": 116,
	"./lb.js": 116,
	"./lo": 117,
	"./lo.js": 117,
	"./lt": 118,
	"./lt.js": 118,
	"./lv": 119,
	"./lv.js": 119,
	"./me": 120,
	"./me.js": 120,
	"./mi": 121,
	"./mi.js": 121,
	"./mk": 122,
	"./mk.js": 122,
	"./ml": 123,
	"./ml.js": 123,
	"./mn": 124,
	"./mn.js": 124,
	"./mr": 125,
	"./mr.js": 125,
	"./ms": 127,
	"./ms-my": 126,
	"./ms-my.js": 126,
	"./ms.js": 127,
	"./mt": 128,
	"./mt.js": 128,
	"./my": 129,
	"./my.js": 129,
	"./nb": 130,
	"./nb.js": 130,
	"./ne": 131,
	"./ne.js": 131,
	"./nl": 133,
	"./nl-be": 132,
	"./nl-be.js": 132,
	"./nl.js": 133,
	"./nn": 134,
	"./nn.js": 134,
	"./pa-in": 135,
	"./pa-in.js": 135,
	"./pl": 136,
	"./pl.js": 136,
	"./pt": 138,
	"./pt-br": 137,
	"./pt-br.js": 137,
	"./pt.js": 138,
	"./ro": 139,
	"./ro.js": 139,
	"./ru": 140,
	"./ru.js": 140,
	"./sd": 141,
	"./sd.js": 141,
	"./se": 142,
	"./se.js": 142,
	"./si": 143,
	"./si.js": 143,
	"./sk": 144,
	"./sk.js": 144,
	"./sl": 145,
	"./sl.js": 145,
	"./sq": 146,
	"./sq.js": 146,
	"./sr": 148,
	"./sr-cyrl": 147,
	"./sr-cyrl.js": 147,
	"./sr.js": 148,
	"./ss": 149,
	"./ss.js": 149,
	"./sv": 150,
	"./sv.js": 150,
	"./sw": 151,
	"./sw.js": 151,
	"./ta": 152,
	"./ta.js": 152,
	"./te": 153,
	"./te.js": 153,
	"./tet": 154,
	"./tet.js": 154,
	"./tg": 155,
	"./tg.js": 155,
	"./th": 156,
	"./th.js": 156,
	"./tl-ph": 157,
	"./tl-ph.js": 157,
	"./tlh": 158,
	"./tlh.js": 158,
	"./tr": 159,
	"./tr.js": 159,
	"./tzl": 160,
	"./tzl.js": 160,
	"./tzm": 162,
	"./tzm-latn": 161,
	"./tzm-latn.js": 161,
	"./tzm.js": 162,
	"./ug-cn": 163,
	"./ug-cn.js": 163,
	"./uk": 164,
	"./uk.js": 164,
	"./ur": 165,
	"./ur.js": 165,
	"./uz": 167,
	"./uz-latn": 166,
	"./uz-latn.js": 166,
	"./uz.js": 167,
	"./vi": 168,
	"./vi.js": 168,
	"./x-pseudo": 169,
	"./x-pseudo.js": 169,
	"./yo": 170,
	"./yo.js": 170,
	"./zh-cn": 171,
	"./zh-cn.js": 171,
	"./zh-hk": 172,
	"./zh-hk.js": 172,
	"./zh-tw": 173,
	"./zh-tw.js": 173
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 237;

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xOSAzaC0xVjFoLTJ2Mkg4VjFINnYySDVjLTEuMTEgMC0xLjk5LjktMS45OSAyTDMgMTljMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWNWMwLTEuMS0uOS0yLTItMnptMCAxNkg1VjhoMTR2MTF6TTcgMTBoNXY1SDd6Ii8+Cjwvc3ZnPg=="

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xOSA2LjQxTDE3LjU5IDUgMTIgMTAuNTkgNi40MSA1IDUgNi40MSAxMC41OSAxMiA1IDE3LjU5IDYuNDEgMTkgMTIgMTMuNDEgMTcuNTkgMTkgMTkgMTcuNTkgMTMuNDEgMTJ6Ii8+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+Cjwvc3ZnPg=="

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTU2Yjc5IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xNyAxLjAxTDcgMWMtMS4xIDAtMiAuOS0yIDJ2MThjMCAxLjEuOSAyIDIgMmgxMGMxLjEgMCAyLS45IDItMlYzYzAtMS4xLS45LTEuOTktMi0xLjk5ek0xNyAxOUg3VjVoMTB2MTR6Ii8+Cjwvc3ZnPg=="

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(229)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-cdbf39c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-5b0dccad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "time-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayTime),
      expression: "displayTime"
    }],
    staticClass: "display-time",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.displayTime)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayTime = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.hideClearButton) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDropdown && _vm.showClearBtn),
      expression: "!showDropdown && showClearBtn"
    }],
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearTime($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "time-picker-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "select-list"
  }, [_c('ul', {
    staticClass: "hours"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.hourType)
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hr) {
    return _c('li', {
      class: {
        active: _vm.hour === hr
      },
      domProps: {
        "textContent": _vm._s(hr)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('hour', hr)
        }
      }
    })
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "minutes"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.minuteType)
    }
  }), _vm._v(" "), _vm._l((_vm.minutes), function(m) {
    return _c('li', {
      class: {
        active: _vm.minute === m
      },
      domProps: {
        "textContent": _vm._s(m)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('minute', m)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.secondType) ? _c('ul', {
    staticClass: "seconds"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.secondType)
    }
  }), _vm._v(" "), _vm._l((_vm.seconds), function(s) {
    return _c('li', {
      class: {
        active: _vm.second === s
      },
      domProps: {
        "textContent": _vm._s(s)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('second', s)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.apmType) ? _c('ul', {
    staticClass: "apms"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.apmType)
    }
  }), _vm._v(" "), _vm._l((_vm.apms), function(a) {
    return _c('li', {
      class: {
        active: _vm.apm === a
      },
      domProps: {
        "textContent": _vm._s(a)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('apm', a)
        }
      }
    })
  })], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            default header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_vm._v("\n             \n            "), _c('button', {
    staticClass: "modal-default-button",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.close) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('ok');
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ok) + "\n            ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!this.authorized && _vm.dataLoaded) ? _c('div', [_vm._v("\nIkke logget ind\n")]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('div', [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: {
      active: _vm.activeTab == 'activities'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('activities')
      }
    }
  }, [_vm._v("Aktiviteter")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'create-activity'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('create-activity')
      }
    }
  }, [_vm._v("Opret Aktivitet")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'series'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('series')
      }
    }
  }, [_vm._v("Serier")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'create-series'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('create-series')
      }
    }
  }, [_vm._v("Opret Serie")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'contact'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('contact')
      }
    }
  }, [_vm._v("Kontakt")]), _vm._v(" "), _c('div', {
    attrs: {
      "onclick": "window.open('https://console.firebase.google.com/project/hscamping-9c323/notification', '_blank')"
    }
  }, [_vm._v("Push-beskeder")]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeTab == 'settings'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('settings')
      }
    }
  }, [_vm._v("Indstillinger")])]), _vm._v(" "), (_vm.activeTab == 'activities') ? _c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSearch),
      expression: "currentSearch"
    }],
    attrs: {
      "placeholder": "søg",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentSearch = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "flatpickr-placeholder"
  }, [_vm._v("vælg dato-interval")]), _vm._v(" "), _c('Flatpickr', {
    ref: "flatpickr",
    attrs: {
      "options": _vm.fpOptionsRange,
      "placeholder": "vælg dato-interval"
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }), _vm._v(" "), (_vm.currentDate) ? _c('img', {
    attrs: {
      "src": __webpack_require__(240),
      "alt": "nulstil kalender"
    },
    on: {
      "click": _vm.resetCurrentDate
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'activities') ? _c('div', [(_vm.currentDateRange && _vm.currentDateRange.from && _vm.currentDateRange.to) ? _c('h2', [_vm._v(_vm._s(_vm._f("localizeDateSimple")(_vm.currentDateRange.from)) + " - " + _vm._s(_vm._f("localizeDateSimple")(_vm.currentDateRange.to)))]) : _vm._e(), _vm._v(" "), (_vm.currentDate === '') ? _c('h2', [_vm._v(_vm._s(_vm._f("localizeDateSimple")(_vm.today)) + " - " + _vm._s(_vm._f("localizeDateSimple")(_vm.aMonthFromNow)))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dates), function(date) {
    return _c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm._f("localizeDate")(date)))]), _vm._v(" "), _vm._l((_vm.filter(_vm.getActivities(date))), function(activity) {
      return _c('div', {
        staticClass: "activity",
        class: {
          past: _vm.isPastActivity(activity)
        }
      }, [_c('img', {
        attrs: {
          "src": activity.pic,
          "alt": "aktivitet"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(activity.title[_vm.currentLang]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(activity.startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(activity.endTimeInMinutes)))]), _vm._v(" "), _c('div', {
        staticClass: "about"
      }, [_vm._v(_vm._s(activity.about[_vm.currentLang]))]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "edit",
        on: {
          "click": function($event) {
            return _vm.edit(activity)
          }
        }
      }, [_vm._v("rediger")]), _vm._v(" "), (activity.title['da']) ? _c('span', {
        staticClass: "translated-da"
      }, [_vm._v("DA")]) : _vm._e(), _vm._v(" "), (activity.title['de']) ? _c('span', {
        staticClass: "translated-de"
      }, [_vm._v("DE")]) : _vm._e(), _vm._v(" "), (activity.series) ? _c('span', {
        staticClass: "series",
        on: {
          "click": function($event) {
            _vm.editSeries(_vm.getSeries(activity.series))
          }
        }
      }, [_vm._v("serie")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "delete",
        on: {
          "click": function($event) {
            return _vm.deleteActivityModal(activity)
          }
        }
      }, [_vm._v("slet")])])])])
    })], 2)
  }), _vm._v(" "), (!_vm.dataLoaded) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), ((_vm.dataLoaded && _vm.dates && _vm.dates.length === 0 && _vm.currentDate !== '') || (_vm.currentDate === '' && _vm.dataLoaded && _vm.dates.length === 0)) ? _c('div', [_vm._v("Ingen aktiviteter")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'edit-activity' || _vm.activeTab == 'edit-series') ? _c('div', [(_vm.activeActivity || _vm.activeSeries) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.title),
      expression: "inputLanguage.title"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Titel (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Titel (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.title[_vm.inputLanguage.title]),
      expression: "activeActivity.title[inputLanguage.title]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.title[_vm.inputLanguage.title])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.title, _vm.inputLanguage.title, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.about),
      expression: "inputLanguage.about"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "about", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Kort beskrivelse (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Kort beskrivelse (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.about[_vm.inputLanguage.about]),
      expression: "activeActivity.about[inputLanguage.about]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.about[_vm.inputLanguage.about])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.about, _vm.inputLanguage.about, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }]
  }, [_c('td', [_vm._v("Dato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.activeActivity.date),
      callback: function($$v) {
        _vm.$set(_vm.activeActivity, "date", $$v)
      },
      expression: "activeActivity.date"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Starttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    on: {
      "change": _vm.onActiveActivityStartTimeChanged
    },
    model: {
      value: (_vm.activeActivityStartTime),
      callback: function($$v) {
        _vm.activeActivityStartTime = $$v
      },
      expression: "activeActivityStartTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sluttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    on: {
      "change": _vm.onActiveActivityEndTimeChanged
    },
    model: {
      value: (_vm.activeActivityEndTime),
      callback: function($$v) {
        _vm.activeActivityEndTime = $$v
      },
      expression: "activeActivityEndTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.location),
      expression: "inputLanguage.location"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Sted (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Sted (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.location[_vm.inputLanguage.location]),
      expression: "activeActivity.location[inputLanguage.location]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.location[_vm.inputLanguage.location])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.location, _vm.inputLanguage.location, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arrangør")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.organiser),
      expression: "activeActivity.organiser"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeActivity.organiser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "organiser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maks antal pladser")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.maxAmountOfParticipants),
      expression: "activeActivity.maxAmountOfParticipants"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.activeActivity.maxAmountOfParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "maxAmountOfParticipants", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.info),
      expression: "inputLanguage.info"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Info (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Info (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.info[_vm.inputLanguage.info]),
      expression: "activeActivity.info[inputLanguage.info]"
    }],
    attrs: {
      "rows": "6",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.activeActivity.info[_vm.inputLanguage.info])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity.info, _vm.inputLanguage.info, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_vm._v("Billede")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onActiveActivityFileChange
    }
  }), _vm._v(" "), (!_vm.activeActivityPreviewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.activeActivity.pic,
      "alt": "aktivitet"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeActivityPreviewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.activeActivityPreviewImage,
      "alt": "aktivitet"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Synlig for")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.visibleTo),
      expression: "activeActivity.visibleTo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "visibleTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "camping"
    }
  }, [_vm._v("Kun HS Camping gæster")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "partner"
    }
  }, [_vm._v("Kun FP gæster")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvem")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.who),
      expression: "activeActivity.who"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "who", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "children"
    }
  }, [_vm._v("Børn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adults"
    }
  }, [_vm._v("Voksne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "family"
    }
  }, [_vm._v("Hele familien")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvor")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.where),
      expression: "activeActivity.where"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "where", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "indoors"
    }
  }, [_vm._v("Indendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outdoors"
    }
  }, [_vm._v("Udendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cafehav"
    }
  }, [_vm._v("Café HAV")])])])]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "villakrea"
    }
  }, [_vm._v("Villa Krea")])])])]), _vm._v(" "),  _c('option', {
    attrs: {
      "value": "vandland"
    }
  }, [_vm._v("Vandland")]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvad")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.what),
      expression: "activeActivity.what"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "what", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sport"
    }
  }, [_vm._v("Sport")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nature"
    }
  }, [_vm._v("Natur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "creative"
    }
  }, [_vm._v("Kreativ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pris-kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.priceCategory),
      expression: "activeActivity.priceCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "priceCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "freeForAll"
    }
  }, [_vm._v("Gratis for alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "freeWithPackage"
    }
  }, [_vm._v("Gratis med aktivitetspakke")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paying"
    }
  }, [_vm._v("Betalende")])])])]), _vm._v(" "), (_vm.activeActivity.priceCategory !== 'freeForAll') ? _c('tr', [_c('td', [_vm._v("Pris (DKK)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.price),
      expression: "activeActivity.price"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.activeActivity.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeActivity, "price", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.category),
      expression: "activeActivity.category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Ikke bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "binding"
    }
  }, [_vm._v("Bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offSite"
    }
  }, [_vm._v("Udenfor pladsen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hereAndNow"
    }
  }, [_vm._v("Her&Nu betaling")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Push-beskeder")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeActivity.pushNotificationMinInAdvance),
      expression: "activeActivity.pushNotificationMinInAdvance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activeActivity, "pushNotificationMinInAdvance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("1 time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("1½ time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("2 timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("2½ timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("3 timer før")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateActiveActivityModal
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-series'),
      expression: "activeTab == 'edit-series'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateActiveSeriesModal
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.updatingActiveActivity) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.activeActivityUpdated && _vm.activeTab == 'edit-activity') ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e(), _vm._v(" "), (_vm.activeActivityUpdated && _vm.activeTab == 'edit-series') ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'edit-activity'),
      expression: "activeTab == 'edit-activity'"
    }]
  }, [_c('h2', [_vm._v("Deltagerliste (" + _vm._s(_vm.getParticipantsAmount(_vm.activeActivity))), (_vm.getMaxAmountOfParticipants(_vm.activeActivity) != null) ? _c('span', [_vm._v("/" + _vm._s(_vm.getMaxAmountOfParticipants(_vm.activeActivity)))]) : _vm._e(), _vm._v(")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantToAdd),
      expression: "participantToAdd"
    }],
    staticClass: "addParticipant",
    attrs: {
      "type": "text",
      "placeholder": "navn"
    },
    domProps: {
      "value": (_vm.participantToAdd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.participantToAdd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.addParticipantModal()
      }
    }
  }, [_vm._v("Tilføj")]), _vm._v(" "), (_vm.showTooManyParticipants) ? _c('div', [_vm._v("Deltagerbegrænsning overskredet")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "participants"
  }, _vm._l((_vm.getParticipants(_vm.activeActivity)), function(participant) {
    return _c('div', {
      staticClass: "participant",
      class: {
        confirmed: participant.confirmed
      },
      on: {
        "click": function($event) {
          return _vm.confirmParticipantModal(participant, _vm.activeActivity, !participant.confirmed)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(participant.name))]), (participant.email) ? _c('span', [_vm._v("(" + _vm._s(participant.email) + ")")]) : _vm._e(), (participant.guestOn) ? _c('span', [_vm._v("- " + _vm._s(_vm.displayGuestOn(participant.guestOn)))]) : _vm._e(), (participant.guestOn) ? _c('span', [_vm._v("("), _c('img', {
      attrs: {
        "src": __webpack_require__(242),
        "height": "18"
      }
    }), _vm._v(")")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "removeButton",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeParticipantModal(participant, _vm.activeActivity)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(241),
        "width": "17"
      }
    })])])
  }), 0), _vm._v(" "), (!_vm.getParticipants(_vm.activeActivity)) ? _c('div', [_vm._v("Ingen deltagere")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'create-activity' || _vm.activeTab == 'create-series') ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.title),
      expression: "inputLanguage.title"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Titel (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Titel (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.title[_vm.inputLanguage.title]),
      expression: "newActivity.title[inputLanguage.title]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.title[_vm.inputLanguage.title])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.title, _vm.inputLanguage.title, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.about),
      expression: "inputLanguage.about"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "about", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Kort beskrivelse (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Kort beskrivelse (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.about[_vm.inputLanguage.about]),
      expression: "newActivity.about[inputLanguage.about]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.about[_vm.inputLanguage.about])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.about, _vm.inputLanguage.about, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-activity'),
      expression: "activeTab == 'create-activity'"
    }]
  }, [_c('td', [_vm._v("Dato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.date),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "date", $$v)
      },
      expression: "newActivity.date"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Startdato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.startDate),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "startDate", $$v)
      },
      expression: "newActivity.startDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Slutdato")]), _c('td', [_c('Flatpickr', {
    attrs: {
      "options": _vm.fpOptions
    },
    model: {
      value: (_vm.newActivity.endDate),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "endDate", $$v)
      },
      expression: "newActivity.endDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }]
  }, [_c('td', [_vm._v("Gentag")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeat),
      expression: "newActivity.repeat"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "repeat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("Daglig")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("Ugentlig")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "monthly"
    }
  }, [_vm._v("Månedlig")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'weekly' || _vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'weekly' || newActivity.repeat === 'monthly'"
    }],
    staticClass: "repeatDays"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'monthly'"
    }]
  }, [_vm._v("Første")]), _vm._v(" "), _c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "0") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "0",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("man")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "1") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("tir")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "2") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("ons")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "3") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("tor")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "4") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("fre")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "5") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("lør")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.repeatDays),
      expression: "newActivity.repeatDays"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.newActivity.repeatDays) ? _vm._i(_vm.newActivity.repeatDays, "6") > -1 : (_vm.newActivity.repeatDays)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newActivity.repeatDays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newActivity, "repeatDays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newActivity, "repeatDays", $$c)
        }
      }
    }
  }), _vm._v("søn")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newActivity.repeat === 'monthly'),
      expression: "newActivity.repeat === 'monthly'"
    }]
  }, [_vm._v("i hver måned")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Starttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    model: {
      value: (_vm.newActivity.startTime),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "startTime", $$v)
      },
      expression: "newActivity.startTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sluttidspunkt")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "minute-interval": 15,
      "hide-clear-button": ""
    },
    model: {
      value: (_vm.newActivity.endTime),
      callback: function($$v) {
        _vm.$set(_vm.newActivity, "endTime", $$v)
      },
      expression: "newActivity.endTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.location),
      expression: "inputLanguage.location"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Sted (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Sted (tysk)")])])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.location[_vm.inputLanguage.location]),
      expression: "newActivity.location[inputLanguage.location]"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.location[_vm.inputLanguage.location])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.location, _vm.inputLanguage.location, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arrangør")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.organiser),
      expression: "newActivity.organiser"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newActivity.organiser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "organiser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Maks antal pladser")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.maxAmountOfParticipants),
      expression: "newActivity.maxAmountOfParticipants"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newActivity.maxAmountOfParticipants)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "maxAmountOfParticipants", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLanguage.info),
      expression: "inputLanguage.info"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inputLanguage, "info", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Info (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Info (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.info[_vm.inputLanguage.info]),
      expression: "newActivity.info[inputLanguage.info]"
    }],
    attrs: {
      "rows": "6",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.newActivity.info[_vm.inputLanguage.info])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity.info, _vm.inputLanguage.info, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_vm._v("Billede")]), _vm._v(" "), _c('td', [_c('input', {
    ref: "newActivityFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.previewImage,
      "alt": "aktivitet"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Synlig for")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.visibleTo),
      expression: "newActivity.visibleTo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "visibleTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "everyone"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "camping"
    }
  }, [_vm._v("Kun HS Camping gæster")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "partner"
    }
  }, [_vm._v("Kun FP gæster")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvem")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.who),
      expression: "newActivity.who"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "who", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "children"
    }
  }, [_vm._v("Børn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "adults"
    }
  }, [_vm._v("Voksne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "family"
    }
  }, [_vm._v("Hele familien")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvor")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.where),
      expression: "newActivity.where"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "where", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "indoors"
    }
  }, [_vm._v("Indendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "outdoors"
    }
  }, [_vm._v("Udendørs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cafehav"
    }
  }, [_vm._v("Café HAV")])])])]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "villakrea"
    }
  }, [_vm._v("Villa Krea")])])])]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vandland"
    }
  }, [_vm._v("Vandland")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hvad")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.what),
      expression: "newActivity.what"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "what", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Intet valgt")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sport"
    }
  }, [_vm._v("Sport")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nature"
    }
  }, [_vm._v("Natur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "creative"
    }
  }, [_vm._v("Kreativ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pris-kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.priceCategory),
      expression: "newActivity.priceCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "priceCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "freeForAll"
    }
  }, [_vm._v("Gratis for alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "freeWithPackage"
    }
  }, [_vm._v("Gratis med aktivitetspakke")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paying"
    }
  }, [_vm._v("Betalende")])])])]), _vm._v(" "), (_vm.newActivity.priceCategory !== 'freeForAll') ? _c('tr', [_c('td', [_vm._v("Pris (DKK)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.price),
      expression: "newActivity.price"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newActivity.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newActivity, "price", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kategori")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.category),
      expression: "newActivity.category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Ikke bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "binding"
    }
  }, [_vm._v("Bindende tilmelding")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offSite"
    }
  }, [_vm._v("Udenfor pladsen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hereAndNow"
    }
  }, [_vm._v("Her&Nu betaling")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Push-beskeder")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newActivity.pushNotificationMinInAdvance),
      expression: "newActivity.pushNotificationMinInAdvance"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newActivity, "pushNotificationMinInAdvance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ingen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("1 time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("1½ time før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("2 timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("2½ timer før")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("3 timer før")])])])])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-activity'),
      expression: "activeTab == 'create-activity'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createActivityModal
    }
  }, [_vm._v("Opret aktivitet")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'create-series'),
      expression: "activeTab == 'create-series'"
    }],
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createSeriesModal
    }
  }, [_vm._v("Opret serie")]), _vm._v(" "), (!_vm.submittable && _vm.submitAttempt) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Vælg et billede!")]) : _vm._e(), _vm._v(" "), (_vm.noActivitiesInSeries) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Serien indeholder ingen aktiviteter!")]) : _vm._e(), _vm._v(" "), (_vm.creatingActivity) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.activityCreated) ? _c('div', [_vm._v("Aktivitet oprettet")]) : _vm._e(), _vm._v(" "), (_vm.seriesCreated) ? _c('div', [_vm._v("Serie oprettet")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'series') ? _c('div', [_vm._l((_vm.series), function(series) {
    return (series.activities) ? _c('div', {
      staticClass: "date",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm._f("localizeDateSimple")(series.startDate)) + " - " + _vm._s(_vm._f("localizeDateSimple")(series.endDate)) + ", " + _vm._s(_vm.mapRepeatToReadableRepeat(series.repeat)))]), _vm._v(" "), (series.repeat === 'weekly' || series.repeat === 'monthly') ? _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('span', [_vm._v("Gentages ")]), (series.repeat === 'monthly') ? _c('span', [_vm._v(" første ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mapRepeatDaysToReadableDays(series.repeatDays)), function(repeatDay, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(repeatDay))])
    }), _vm._v(" "), (series.repeat === 'monthly') ? _c('span', [_vm._v("i hver måned")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series))) ? _c('div', {
      staticClass: "activity",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getActivity(_vm.getFirstActivityKey(series)).pic,
        "alt": "aktivitet"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getActivity(_vm.getFirstActivityKey(series)).title[_vm.currentLang]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("minutesToTimeOfDay")(_vm.getActivity(_vm.getFirstActivityKey(series)).startTimeInMinutes)) + " - " + _vm._s(_vm._f("minutesToTimeOfDay")(_vm.getActivity(_vm.getFirstActivityKey(series)).endTimeInMinutes)))]), _vm._v(" "), _c('div',  {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.getActivity(_vm.getFirstActivityKey(series)).about[_vm.currentLang]))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          return _vm.editSeries(series)
        }
      }
    }, [_vm._v("rediger")]), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series)).title['da']) ? _c('span', {
      staticClass: "translated-da"
    }, [_vm._v("DA")]) : _vm._e(), _vm._v(" "), (_vm.getActivity(_vm.getFirstActivityKey(series)).title['de']) ? _c('span', {
      staticClass: "translated-de"
    }, [_vm._v("DE")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteSeriesModal(series)
        }
      }
    }, [_vm._v("slet")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(Object.keys(series.activities).length) + " aktiviteter i serie")])]) : _vm._e()
  }), _vm._v(" "), (_vm.series && _vm.series.length === 0) ? _c('div', [_vm._v("Ingen serier")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'contact') ? _c('div', [(_vm.contact) ? _c('table', [_c('tr', [_c('td', [_vm._v("\n                    Kontakt info\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.info),
      expression: "contact.info"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.contact.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateContact
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.contactUpdated) ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'push-notifications') ? _c('div') : _vm._e(), _vm._v(" "), (_vm.activeTab == 'settings') ? _c('div', [_c('button', {
    on: {
      "click": _vm.deleteOldActivities
    }
  }, [_vm._v("Slet gamle aktiviteter")]), _vm._v(" "), _c('div', [_vm._v("(mere end en måned gamle)")]), _vm._v(" "), (_vm.deletingOldActivities) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.oldActivitiesDeleted) ? _c('div', [_vm._v("Gamle aktiviteter slettet")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Pop-up beskeder ved aktivitet-tilmelding")]), _vm._v(" "), _c('table', {
    staticClass: "edit-activity"
  }, [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.hereAndNow),
      expression: "signupNotesInputLanguage.hereAndNow"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "hereAndNow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Her&Nu betaling (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Her&Nu betaling (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.hereAndNow[_vm.signupNotesInputLanguage.hereAndNow]),
      expression: "signupNotes.hereAndNow[signupNotesInputLanguage.hereAndNow]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.hereAndNow[_vm.signupNotesInputLanguage.hereAndNow])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.hereAndNow, _vm.signupNotesInputLanguage.hereAndNow, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.binding),
      expression: "signupNotesInputLanguage.binding"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "binding", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Bindende tilmelding (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Bindende tilmelding (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.binding[_vm.signupNotesInputLanguage.binding]),
      expression: "signupNotes.binding[signupNotesInputLanguage.binding]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.binding[_vm.signupNotesInputLanguage.binding])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.binding, _vm.signupNotesInputLanguage.binding, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.free),
      expression: "signupNotesInputLanguage.free"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "free", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Ikke bindende tilmelding (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Ikke bindende tilmelding (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.free[_vm.signupNotesInputLanguage.free]),
      expression: "signupNotes.free[signupNotesInputLanguage.free]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.free[_vm.signupNotesInputLanguage.free])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.free, _vm.signupNotesInputLanguage.free, $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotesInputLanguage.offSite),
      expression: "signupNotesInputLanguage.offSite"
    }],
    staticClass: "lang-dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.signupNotesInputLanguage, "offSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Udenfor pladsen (dansk)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Udenfor pladsen (tysk)")])])]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupNotes.offSite[_vm.signupNotesInputLanguage.offSite]),
      expression: "signupNotes.offSite[signupNotesInputLanguage.offSite]"
    }],
    attrs: {
      "rows": "8",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.signupNotes.offSite[_vm.signupNotesInputLanguage.offSite])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupNotes.offSite, _vm.signupNotesInputLanguage.offSite, $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateSignupNotes
    }
  }, [_vm._v("Gem ændringer")]), _vm._v(" "), (_vm.signupNotesUpdated) ? _c('div', [_vm._v("ændringer gemt")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.modal.show) ? _c('modal', {
    attrs: {
      "ok": _vm.modal.ok,
      "close": _vm.modal.close
    },
    on: {
      "ok": _vm.modal.action,
      "close": function($event) {
        _vm.modal.show = false
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    domProps: {
      "textContent": _vm._s(_vm.modal.header)
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.modal.body)
    },
    slot: "body"
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

},[184]);


// WEBPACK FOOTER //
// static/js/app.ace80bc96d162bab449e.js